import { lazy } from "react";

const MainPage = lazy(() => import("./"));

const routes = [
  {
    path: "/administration/kpis",
    component: MainPage,
    exact: true,
    name: "Asignación de KPI's"
  }
];

export default routes;
